import React, { FC } from 'react';

export const EmailSentSvg: FC<{}> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="74"
    viewBox="0 0 62 74"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
      transform="translate(-1555 -420) translate(1494 421) translate(62)"
    >
      <path
        fill="#171E3A"
        d="M57.1052903 39.5101935L49.0807742 33.0901935 49.0807742 45.1289032z"
      ></path>
      <path
        fill="#FFF"
        fillOpacity="0.5"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M57.1052903 39.5101935L49.0807742 33.0901935 49.0807742 45.1289032z"
      ></path>
      <path
        fill="#171E3A"
        d="M15.7428387 33.0903871L7.71832258 39.5103871 15.7428387 45.1290968z"
      ></path>
      <path
        fill="#FFF"
        fillOpacity="0.5"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.7428387 33.0903871L7.71832258 39.5103871 15.7428387 45.1290968z"
      ></path>
      <path
        fill="#171E3A"
        d="M49.08 45.129L33.828 55.805a2.468 2.468 0 01-2.833 0L15.743 45.129l-8.026-5.62v29.635a2.47 2.47 0 002.47 2.47h44.45a2.47 2.47 0 002.467-2.47V39.51l-8.024 5.619z"
      ></path>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M49.08 45.129L33.828 55.805a2.468 2.468 0 01-2.833 0L15.743 45.129l-8.026-5.62v29.635a2.47 2.47 0 002.47 2.47h44.45a2.47 2.47 0 002.467-2.47V39.51l-8.024 5.619z"
      ></path>
      <path
        fill="#171E3A"
        d="M15.743 14.817v30.311l15.251 10.676a2.468 2.468 0 002.834 0L49.08 45.128V14.817H15.743z"
      ></path>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.743 14.817v30.311l15.251 10.676a2.468 2.468 0 002.834 0L49.08 45.128V14.817H15.743z"
      ></path>
      <path
        stroke="#EE295C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2.47 24.694v4.94M0 27.164h4.94M56.796 4.939v4.94M54.327 7.408h4.94"
      ></path>
      <path
        stroke="#00A8FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22.533 29.633H42.29"
      ></path>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.817 0v4.94M6.086 3.617l1.322 1.322M2.47 12.347h4.939"
      ></path>
    </g>
  </svg>
);
